var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4D4D4D;stroke:#000000;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.64,9.59h-6.51c2.19-0.09,2.19-0.09,2.19-3.05c0-1.69-1.96-3.05-4.38-3.05s-4.38,1.37-4.38,3.05 c0,2.96,0,2.96,2.19,3.05H7.17L1.72,24.72l3.77,3.96h10.45h10.45l3.77-3.96L24.64,9.59z M15.94,8.09c-2.78,0-2.78,0-2.78-1.56 c0-0.85,1.25-1.56,2.78-1.56s2.78,0.69,2.78,1.56C18.72,8.09,18.72,8.09,15.94,8.09z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.701d0be76562a87ea7ad14f9212a84e9.svg";
export { ForwardRef as ReactComponent };